<template>
    <el-dialog
        :visible.sync="bindPhoneVisible"
        :show-close="false"
        center
        width="500px"
        :before-close="handleClose">
        <div class="reset">
            <div class="reset_title">绑定账号</div>
            <div class="reset_input">
                <img class="reset_input_img1" src="../assets/login/login_phone.png" >
                <el-input v-model="registerForm.phone" placeholder="请填写手机号"></el-input>
            </div>
            <div class="reset_input2">
                <img class="reset_input2_img2" src="../assets/login/login_message.png" >
                <el-input v-model="registerForm.code" placeholder="请填写验证码"></el-input>
                <div class="reset_input2_code">
                    <div class="reset_input2_code_get" v-if="num <= 0" @click="getCode">发送验证码</div>
                    <div class="reset_input2_code_get1" v-else>已发送/{{num}}s</div>
                </div>
            </div>
            <div class="reset_input" v-if="isBindPhone">
                <img class="reset_input_img1" src="../assets/login/login_reset.png" >
                <el-input v-model="registerForm.password" type="password" placeholder="请填写账号密码"></el-input>
            </div>
            <div class="reset_input" v-if="isBindPhone">
                <img class="reset_input_img1" src="../assets/login/login_reset.png" >
                <el-input v-model="registerForm.confirmPassword" type="password" placeholder="请重复账号密码"></el-input>
            </div>
            <el-button class="reset_btn" type="primary" @click="submit">绑定</el-button>
            <!-- <div class="reset_handle">
                <p>
                    已有账号？<el-button type="text" @click="$emit('register','loginVisible');">切换到手机账号登录</el-button>
                </p>
                
            </div> -->
        </div>
        

    </el-dialog>
   
</template>

<script>
export default {
    props:["bindPhoneVisible","loginPath"],
   data (){
       return {
           registerForm:{
                phone:'',
                code:'',
                password:'',
                confirmPassword:''
           },
           isFirstCode:false,
           num:0,
           isBindPhone:false
           
       }
   },
   components: {
       
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       handleClose(){
           this.$emit("update:bindPhoneVisible",false)
       },
        getQueryString(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            var r = window.location.search.substr(1).match(reg);
            if (r != null) return unescape(r[2]); return null;
        },
        getCode(){
            
            if(!this.isPhoneNo(this.registerForm.phone)){
                this.$message.error('请输入正确的手机号');
                return
            }
            this.$get('CheckMobileRegister/' + this.registerForm.phone)
                .then(res => {
                    this.isBindPhone = res.status ? false : true;
                    this.$post('SendSmsCode',{mobile:this.registerForm.phone})
                        .then(data => {
                            this.isCode = true;
                            this.num = 59;
                            let timer = setInterval(()=> {
                                this.num --;
                                if(this.num == 0){
                                    clearInterval(timer);
                                }
                            },1000);
                        } , error => {
                            this.$message.error(error);
                        });
                }, error => {
                    this.$message.error(error);
                });
            
        },
        submit(){
            if(!this.isPhoneNo(this.registerForm.phone)){
                this.$message.error('请输入正确的手机号');
                return
            }
            if(!this.registerForm.code){
                this.$message.error('请填写验证码');
                return
            }

            let params = {
                mobile:this.registerForm.phone,
                code:this.registerForm.code,
                password:this.registerForm.password,
                fid:''
            }
            if(this.isBindPhone){
                if(this.registerForm.password != this.registerForm.confirmPassword){
                    this.$message.error('两次密码填写不一致！');
                    return
                }
            }else{
                delete params.password
            }
             
            if(this.getQueryString('fid')){
                params.fid = this.getQueryString('fid');
            }
            this.$post('User',params).then(data => {
                this.$message.success('绑定成功！');
                localStorage.setItem('userMessage',JSON.stringify(Object.assign(data,data.user)));
                this.$eventBus.$emit('changeUserInfo',{});
                this.handleClose();
                if(this.loginPath){
                    this.$router.push(this.loginPath);
                }else{
                    this.$router.push({path:'/message'});
                }
            } , error => {
                this.$message.error(error);
            });
        },
        isPhoneNo(phone) {
            var pattern = /^[1][3-9][0-9]{9}$/;
            return pattern.test(phone);
        }  
   },
   created() {
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.reset{
    padding: 0 35px;
    &_title{
        font-size: 24px;
        font-weight: 500;
        color:#333333;
        text-align: center;
    }
    &_input{
        margin-top:24px;
        position: relative;
        &_img1{
            width:20px;
            position: absolute;
            top: 16px;
            left: 16px;
            z-index:1;
        }
        /deep/ input{
            height:60px;
            font-size:20px;
            padding-left:54px;
        }
        
    }
    &_input2{
        margin-top:24px;
        position: relative;
        /deep/ input{
            height:60px;
            font-size:20px;
            padding-left:54px;
            padding-right:128px;
        }
        &_img2{
            width:30px;
            position: absolute;
            top: 16px;
            left: 14px;
            z-index:1;
        }
        &_code{
            height:34px;
            width:128px;
            border-left:1px solid #CFD7E0;
            padding-left:8px;
            position: absolute;
            right:0;
            top:13px;
            &_get{
                font-size: 20px;
                line-height: 34px;
                color:#009AFF;
                cursor: pointer;
            }
            &_get1{
                font-size: 20px;
                line-height: 34px;
                color:#999999;
            }
        }
    }
    &_btn{
        width:100%;
        margin-top:26px;
    }
    /deep/ &_btn.el-button{
        height: 54px;
        font-size: 18px;
        background:#5999FF;
    }
    &_handle{
        padding: 10px 0 0 0;
        text-align: right;
        p{
            font-size: 18px;
            font-weight: 400;
        }
        /deep/ .el-button--text{
            font-size:18px;
            color:#009AFF;
            font-weight: 400;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/bindPhone.vue